import { render, staticRenderFns } from "./SummaryDocuments.vue?vue&type=template&id=32521af4&scoped=true&"
import script from "./SummaryDocuments.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryDocuments.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummaryDocuments.vue?vue&type=style&index=0&id=32521af4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32521af4",
  null
  
)

export default component.exports